import { render, staticRenderFns } from "./class_mode.vue?vue&type=template&id=fd237fe8&scoped=true"
import script from "./class_mode.vue?vue&type=script&lang=js"
export * from "./class_mode.vue?vue&type=script&lang=js"
import style0 from "./class_mode.vue?vue&type=style&index=0&id=fd237fe8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd237fe8",
  null
  
)

export default component.exports